var render, staticRenderFns
import script from "./DiyTable.vue?vue&type=script&lang=js"
export * from "./DiyTable.vue?vue&type=script&lang=js"
import style0 from "./DiyTable.vue?vue&type=style&index=0&id=59d9da5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9da5c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/components/DiyTable.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_MPORTAL%2Fsrc%2Fcomponents%2FDiyTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports